/** Dedupe de arquivos de entrega (mesma lógica do mobile). */
export function dedupeDeliveryFiles(files) {
  if (!Array.isArray(files) || files.length === 0) return [];
  const byId = new Map();
  const extras = [];

  const rank = (x) => ((x.client_status || '') === 'revision_requested' ? 2 : 0);

  files.forEach((f, idx) => {
    if (!f || typeof f !== 'object') return;
    const raw = f.id != null ? String(f.id).trim() : '';
    if (raw) {
      const existing = byId.get(raw);
      if (!existing) {
        byId.set(raw, f);
        return;
      }
      if (rank(f) > rank(existing)) byId.set(raw, f);
      return;
    }
    extras.push({ ...f, __dedupeIdx: idx });
  });

  return [...byId.values(), ...extras];
}

export function clientStatusLabel(status) {
  const s = status || 'pending';
  if (s === 'approved') return 'Aprovada';
  if (s === 'revision_requested') return 'Revisão';
  if (s === 'pending') return 'Aguardando';
  return s;
}

export function resolveMime(filename, mimeType) {
  const ext = (filename || '').split('.').pop()?.toLowerCase();
  const mimeByExt = {
    mp4: 'video/mp4',
    m4v: 'video/mp4',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    webm: 'video/webm',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
  };
  return (
    mimeByExt[ext] ||
    (typeof mimeType === 'string' && mimeType.includes('/') ? mimeType : null) ||
    'application/octet-stream'
  );
}

export function needsDeliveryPolling(delivery, job) {
  if (!delivery) return false;
  if (delivery.status === 'delivery_processing') return true;
  if (job?.status === 'delivery_processing') return true;
  const files = delivery.files || [];
  return files.some(
    (f) =>
      (f.content_type || '').startsWith('video/') &&
      f.processing_status &&
      f.processing_status !== 'completed' &&
      f.processing_status !== 'failed'
  );
}
